import { Icon, type IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import { createElement } from "react";
import type { ColorValue } from "@-/com.npmjs.react-native";

const morphemePanelTabIconDict: Record<string, IconName> = {
  info: "LuBookOpen",
  mnemonics: "MdLightbulbOutline",
};

export function morphemePanelTabBarIcon(screenName: string) {
  // Intentionally ignore the `color` arg: forwarding it as the Icon's `color` prop overrides the
  // theme-aware `className` (`Icon` prefers an explicit `color` over the resolved className color),
  // which made the focused icon black-on-dark (invisible) in dark mode. Let the className drive it.
  return ({ focused }: { color: ColorValue; focused: boolean }) =>
    createElement(Icon, {
      className: focused ? "text-foreground" : "text-muted-foreground/60",
      name: morphemePanelTabIconDict[screenName] ?? "LuHelpCircle",
      size: screenName === "mnemonics" ? 15 : 14,
    });
}
